// routes/_embedded.embedded.user-referral.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_embedded.embedded.user-referral')

export const handle = { name: 'embedded-referral-page' }

export default dynamic(getClientModule, { ssr: false })
